/**
 * Labstep
 *
 * @module models/global-search-result
 * @desc Typescript export class for global search result
 */

import { PartialEntity } from 'labstep-web/models/partial-entity.model';

export class GlobalSearchResult extends PartialEntity {
  public data!: string;

  public organization_id!: number[];

  public group_id!: number[];
}
